
/* ============================================================================
   NAVEGACIÓN POR PÁGINAS
   Cada opción del menú ☰ abre su propia página con URL propia:
     #/caballero  #/dama  #/unisex  #/ambientales
     #/best-sellers  #/encuentra-tu-aroma  #/novedades
   Se usa "#/" para no pisar los anclajes de la portada (#catalogo, #finder…).
   Al integrar en Shopify, cada ruta equivale a una colección /collections/<handle>.
   ============================================================================ */
(function(){
  var catHero=document.getElementById('catHero'), howto=document.getElementById('howto');
  var SEC={
    hero:document.querySelector('.hero'),
    season:document.querySelector('.season'),
    reviews:document.querySelector('.reviews'),
    finder:document.getElementById('finder'),
    best:document.getElementById('bestsellers'),
    catalogo:document.getElementById('catalogo'),
    values:document.querySelector('.values'),
    story:document.querySelector('.story'),
    nuevos:document.getElementById('nuevos')
  };
  var divisores=[].slice.call(document.querySelectorAll('.divider'));

  // ruta -> { título, subtítulo, secciones visibles, categoría del catálogo }
  var RUTAS={
    'caballero'   :{t:'Caballero',          e:'Colección', para:'Caballero',  ver:['catalogo']},
    'dama'        :{t:'Dama',               e:'Colección', para:'Dama',       ver:['catalogo']},
    'unisex'      :{t:'Unisex',             e:'Colección', para:'Unisex',     ver:['catalogo']},
    'ambientales' :{t:'Ambientales',        e:'Colección', para:'Ambiental',  ver:['catalogo'],
                    s:'Aromas para tu espacio'},
    'best-sellers':{t:'Best Sellers',       e:'Los favoritos', ver:['best'],
                    s:'Las fragancias más elegidas por nuestros clientes en Hermosillo'},
    'novedades'   :{t:'Novedades 2026',     e:'Recién llegados', ver:['nuevos'],
                    s:'Las incorporaciones más recientes a la colección Velantis'},
    'encuentra-tu-aroma':{t:'Encuentra tu nuevo aroma', e:'Asesoría olfativa', ver:['finder','catalogo'],
                    howto:true, s:'Elige tus notas favoritas y descubre tu fragancia ideal'}
  };

  function mostrarTodo(v){
    Object.keys(SEC).forEach(function(k){ if(SEC[k]) SEC[k].hidden=!v; });
    divisores.forEach(function(d){ d.hidden=!v; });
    // al volver a la portada, restaurar todos los títulos de sección
    if(v) document.querySelectorAll('.sec-head[hidden]').forEach(function(sh){ sh.hidden=false; });
  }

  function ir(){
    var hash=location.hash||'';
    if(hash.indexOf('#/')!==0){          // no es ruta: portada (los anclajes siguen igual)
      document.body.classList.remove('ruta');
      catHero.hidden=true; howto.hidden=true; mostrarTodo(true);
      if(window.VelantisCatalogo) window.VelantisCatalogo.setPara('');
      return;
    }
    var clave=hash.slice(2).replace(/\/$/,'');
    var r=RUTAS[clave];
    if(!r){                              // #/ o ruta desconocida -> portada
      document.body.classList.remove('ruta');
      catHero.hidden=true; howto.hidden=true; mostrarTodo(true);
      if(window.VelantisCatalogo) window.VelantisCatalogo.setPara('');
      window.scrollTo(0,0);
      return;
    }
    document.body.classList.add('ruta');
    mostrarTodo(false);
    r.ver.forEach(function(k){ if(SEC[k]) SEC[k].hidden=false; });
    catHero.hidden=false;
    howto.hidden=!r.howto;
    document.getElementById('chEyebrow').textContent=r.e;
    document.getElementById('chTitle').textContent=r.t;
    var n=(r.para && window.VelantisCatalogo)? window.VelantisCatalogo.count(r.para):0;
    document.getElementById('chSub').textContent = r.para
      ? n+' fragancias · precio único $449 MXN'
      : (r.s||'');
    if(window.VelantisCatalogo) window.VelantisCatalogo.setPara(r.para||'');
    // el título de la sección principal sobra (ya lo dice la portada); las demás lo conservan
    r.ver.forEach(function(k,idx){
      var sh=SEC[k]&&SEC[k].querySelector('.sec-head'); if(sh) sh.hidden=(idx===0);
    });
    document.title='Velantis · '+r.t;
    window.scrollTo(0,0);
  }

  window.addEventListener('hashchange',ir);
  ir();
})();
